// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"654":"6779430551a85ad15e60","702":"3f60842623a47f8507db"}[chunkId] + "/" + chunkId + ".chunk.js";
};